import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

const config: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: 0, // default: 3
    },
    mutations: {
      retry: 0, // default: 3
    },
  },
};

export const appQueryClient = new QueryClient(config);
export const testQueryClient = new QueryClient(config);
